import { Component, inject, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DyeingGroupSummary } from '../../../models/production/dyeing/dyeing-forecast-forms';
import { DyeingForecastService } from '../../../services/dyeing-forecast.service';
import { Asset } from '../../../models/asset/asset';
import { WorkOrder } from '../../../models/order/work-order';
import { WorkOrderProxyService } from '../../../proxies/order/work-order.proxy.service';
import { WorkOrderEstmatedDate } from '../../../models/order/work-order';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-dyeing-details-card',
  templateUrl: './dyeing-details-card.component.html',
  styleUrl: './dyeing-details-card.component.scss',
})
export class DyeingDetailsCardComponent implements OnInit {
  @Input() assets: Asset[] = [];
  @Input() workOrder!: WorkOrder;
  @Input() onlyView = false;
  tabOptions: { label: string; value: number }[] = [];
  tabControl = new FormControl(0);

  planningForm = new FormGroup({
    customerServicePromisedDate: new FormControl<Date | null>({ value: null, disabled: true }),
    knittingEstimatedEndDate: new FormControl<Date | null>(null),
    dyeingEstimatedEndDate: new FormControl<Date | null>(null),
    finishingEstimatedEndDate: new FormControl<Date | null>(null),
    actualFinishedDate: new FormControl<Date | null>({ value: null, disabled: true }),
  });

  private readonly DyeingForecastService = inject(DyeingForecastService);
  private readonly workOrderProxyService = inject(WorkOrderProxyService);
  private readonly translateService = inject(TranslateService);

  constructor() {
    this.tabOptions = [
      { label: this.translateService.instant('General'), value: 0 },
      { label: this.translateService.instant('Summary'), value: 1 },
      { label: this.translateService.instant('Machines'), value: 2 },
      { label: this.translateService.instant('Info'), value: 3 },
    ];
  }

  ngOnInit(): void {
    this.initFormFromWorkOrder();

    if (this.onlyView) {
      this.applyViewMode();
    }
  }

  private initFormFromWorkOrder(): void {
    if (!this.workOrder) return;

    this.planningForm.patchValue({
      customerServicePromisedDate: new Date(this.workOrder.estimatedShipmentDate),
      knittingEstimatedEndDate: this.workOrder.estimatedDatesPlanning?.knittingEstimatedEndDate
        ? new Date(this.workOrder.estimatedDatesPlanning.knittingEstimatedEndDate)
        : null,
      dyeingEstimatedEndDate: this.workOrder.estimatedDatesPlanning?.dyeingEstimatedEndDate
        ? new Date(this.workOrder.estimatedDatesPlanning.dyeingEstimatedEndDate)
        : null,
      finishingEstimatedEndDate: this.workOrder.estimatedDatesPlanning?.finishingEstimatedEndDate
        ? new Date(this.workOrder.estimatedDatesPlanning.finishingEstimatedEndDate)
        : null,
    });
  }

  saveEstimatedDates(): void {
    if (!this.workOrder) return;

    const formValues = this.planningForm.value;

    const payload: WorkOrderEstmatedDate = {
      knittingEstimatedEndDate: formValues.knittingEstimatedEndDate?.toISOString(),
      dyeingEstimatedEndDate: formValues.dyeingEstimatedEndDate?.toISOString(),
      finishingEstimatedEndDate: formValues.finishingEstimatedEndDate?.toISOString(),
    };

    this.workOrderProxyService.patchWorkOrdeEstimatedDate(this.workOrder.id, payload).subscribe({
      next: (updated) => console.log('Fechas actualizadas:', updated),
      error: (err) => console.error('Error al actualizar fechas', err),
    });
  }

  get dyeingForecastSummary() {
    return this.DyeingForecastService.dyeingGroupsSummary;
  }

  geTotalNeeded(dyeingGroupSummary: DyeingGroupSummary): number {
    return dyeingGroupSummary.fabrics.reduce((sum, f) => sum + (f.quantityRequiredInUOM ?? 0), 0);
  }

  getTotalPlanning(dyeingGroupSummary: DyeingGroupSummary): number {
    return dyeingGroupSummary.fabrics.reduce((sum, f) => sum + (f.quantityPlannedInUOM ?? 0), 0);
  }

  getTotalRemaining(dyeingGroupSummary: DyeingGroupSummary): number {
    return this.geTotalNeeded(dyeingGroupSummary) - this.getTotalPlanning(dyeingGroupSummary);
  }

  applyViewMode() {
    this.planningForm.disable({ emitEvent: true });
  }
}
